export function trimPlusNewline(raw: string): string {
  return (
    raw
      // Remove real newlines (CR/LF/LS/PS)
      .replace(/(\r\n|\r|\n|\u2028|\u2029)/g, '')
      // Remove literal "\n" and "\r"
      .replace(/\\[nr]/g, '')
      // Remove HTML breaks
      .replace(/<br\s*\/?>/gi, '')
      // Remove numeric entities for CR/LF
      .replace(/&#(?:10|13);/g, '')
      // Finally trim any stray spaces
      .trim()
  );
}
